import { classNames } from '@dimjs/utils';
import { getGlobalData, toLinkPath } from '@flatbiz/utils';
import { Breadcrumb } from 'antd';
import { Fragment, useMemo, type ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { bootstrapCtx } from '../../context/layout-ctx';
import { useIframe } from '../../hooks';
import { useBread } from '../../hooks/use-bread';
import { type TGlobalData } from '../../types';
import './bread.less';
type BreadProps = {
  children?: ReactElement;
};

export const Bread = (props: BreadProps) => {
  const ctx = bootstrapCtx();
  const iframeApi = useIframe();
  const globalData = getGlobalData<TGlobalData>();
  const breadRoutes = useBread(ctx.breads || {}, globalData.routeBaseName);
  const breadcrumbItems = useMemo(() => {
    const items = ctx.breadTitle ? [{ title: ctx.breadTitle }] : [];
    const routes = breadRoutes.sort((a, b) => {
      return a.path.length - b.path.length;
    });
    routes.forEach((item, index) => {
      const content = item && <Fragment>{item.name}</Fragment>;
      if (item) {
        if (routes.length - 1 !== index) {
          items.push({
            title: (
              <Link
                to={toLinkPath(item.path, item.query)}
                onClick={() => {
                  if (ctx.layoutMode === 'iframe-tab') {
                    iframeApi.tabItemRedDotToggle(false);
                  }
                }}
              >
                {content}
              </Link>
            ),
          });
        } else {
          items.push({ title: item.name });
        }
      }
    });
    return items;
  }, [breadRoutes, ctx.breadTitle]);

  if (!breadRoutes.length) {
    return null;
  }
  return (
    <div className="bread-wrapper">
      <Breadcrumb
        {...ctx.breadcrumbProps}
        className={classNames('bread', ctx.breadcrumbProps?.className)}
        items={breadcrumbItems}
      />
      <div className="bread-extend">{props.children}</div>
    </div>
  );
};
